"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M725.6 644h-45.1l-15.7-16c55.4-66.6 89.2-152.9 89.2-247.4C753.9 170.4 588.5 0 384.3 0S14.8 170.4 14.8 380.5 180.3 761 384.4 761c91.8 0 175.6-34.7 240.2-91.7l15.7 16v46.4L924.5 1024l84.8-87.3L725.6 644zm-341.3 0C243 644 128.5 526.1 128.5 380.5c0-145.5 114.5-263.4 255.9-263.4 141.3 0 255.9 118 255.9 263.4-.1 145.6-114.7 263.5-256 263.5z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgSearch, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;